export default "__VITE_PUBLIC_ASSET__c5edbdc4__"